import { DatePipe } from "@angular/common";
import { Component } from '@angular/core';
import { SplitByCapitalLetterPipePipe } from '@shared/pipes/split-by-capital-letter-pipe.pipe';
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from 'ag-grid-community';
import { SignatureStatus } from '@models/documents/signature-status.enum';
import { BulkSignatoryGroup } from '@models/documents/sign-documents';

@Component({
  selector: 'app-ag-bulk-signatory-status',
  standalone: true,
  imports: [
    SplitByCapitalLetterPipePipe,
    DatePipe
  ],
  templateUrl: './ag-bulk-signatory-status.component.html',
  styleUrl: './ag-bulk-signatory-status.component.scss'
})
export class AgBulkSignatoryStatusComponent implements ICellRendererAngularComp {
  protected status: SignatureStatus | null | undefined;
  protected signedOn = '';
  protected readonly SignatureStatus = SignatureStatus;

  agInit(params: ICellRendererParams<BulkSignatoryGroup, SignatureStatus>): void {
    //this.status = params.value;
    this.status = params.data?.signatoryStatus;

    //this.signedOn = params.data?.signedOn ?? '';
  }

  refresh(params: ICellRendererParams<BulkSignatoryGroup, SignatureStatus>): boolean {
    this.status = params.value;
    //this.signedOn = params.data?.signedOn ?? ''; // TODO add
    return true;
  }

}
